var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "shape-eye",
  "use": "shape-eye-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"shape-eye\"><path d=\"M8 10.571c-1.406 0-2.545-1.15-2.545-2.571 0-1.421 1.139-2.571 2.545-2.571S10.545 6.579 10.545 8c0 1.421-1.139 2.571-2.545 2.571M8 3.5C3.958 3.5 1 8 1 8s2.958 4.5 7 4.5S15 8 15 8s-2.958-4.5-7-4.5z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-sprite/shape-eye.svg
// module id = 180
// module chunks = 72698250460545 114276838955818